import { useState } from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "../../services/Token";
import ResignationQueue from "./ResignationQueue";
import AdminResignationDetail from "./AdminResignationDetail";
import EmployeeResignation from "./EmployeeResignation";

// One route, two audiences. Admin/HR lands on the review queue; employees get
// their own resignation flow. Managers are excluded from the feature entirely
// (2026-08-25) - the sidebar hides the entry and this guard covers a direct hit
// on /resignation. An account carrying both ADMIN and MANAGER stays a reviewer.
const ResignationExit = () => {
  const roles = getToken("roles") || "";
  const isReviewer = roles.includes("ADMIN");
  const isManagerOnly = roles.includes("MANAGER") && !isReviewer;
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);

  if (isManagerOnly) {
    return <Navigate to="/dashboard" replace />;
  }

  if (!isReviewer) {
    return <EmployeeResignation />;
  }

  return (
    <div className="p-6 space-y-5">
      {/* <header>
        <h1 className="text-xl font-semibold text-gray-800">Resignation &amp; Exit</h1>
        <p className="text-sm text-gray-500">
          Approve resignation requests and verify exit-clearance documents.
        </p>
      </header> */}

      {selectedEmployeeId ? (
        <AdminResignationDetail
          employeeId={selectedEmployeeId}
          onBack={() => setSelectedEmployeeId(null)}
        />
      ) : (
        <ResignationQueue onSelect={setSelectedEmployeeId} />
      )}
    </div>
  );
};

export default ResignationExit;
